export default __webpack_public_path__ + "static/media/polygon-home.e26c4e35.svg";